import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { getParam } from '@this/src/util';
import SelectTab from '../share/SelectTab';
import Total from './total/total';
import Items from './items/items';

const BizEkinetTab = {
  TOTAL: '総数',
  ITEMS: '全件'
} as const;
export type BizEkinetTabType = keyof typeof BizEkinetTab;

const BizEkinetBooking = observer(() => {
  const history = useHistory();
  const [bizEkinetBookingTab, setBizEkinetBookingTab] = useState<BizEkinetTabType>(
    (getParam('biz_ekinet_booking_type') as BizEkinetTabType) ||
      (getParam('biz_ekinet_booking_tab') as BizEkinetTabType) ||
      'TOTAL'
  );

  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
    currentParams.set('sub_tab', 'BIZ_EKINET_BOOKING');
    if (!currentParams.has('biz_ekinet_booking_type')) {
      currentParams.set('biz_ekinet_booking_type', bizEkinetBookingTab);
    }
    history.replace(`/arrangement/todo_list?${currentParams.toString()}`);
  }, [history, bizEkinetBookingTab]);

  const handleTabChange = useCallback(
    (tab: BizEkinetTabType) => {
      setBizEkinetBookingTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'BIZ_EKINET_BOOKING');
      currentParams.set('biz_ekinet_booking_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  return (
    <>
      <SelectTab tabs={BizEkinetTab} currentTab={bizEkinetBookingTab} onChange={handleTabChange} />
      {bizEkinetBookingTab === 'TOTAL' ? <Total /> : <Items />}
    </>
  );
});

export default BizEkinetBooking;
